import { useEffect, useRef, useState } from "react";

import Head from "next/head";
import PropTypes from "prop-types";

import getUserProperties from "@/users/getUserProperties";
import videoPlayerEvents from "@/view/constants/videoPlayerEvents";
import shapeQuizResponseData from "@/view/utils/shapeQuizResponseData";
import useGetVideoQuizSubmission from "@/view/utils/useGetVideoQuizSubmission";
import useVideoEventBus from "@/view/utils/useVideoEventBus";
import { addVeilCss } from "./VideoEmbed.style";
import shapeContextValue from "./shapeContextValue";

const propTypes = {
  contentId: PropTypes.string,
  src: PropTypes.string,
  user: PropTypes.object,
  showVeil: PropTypes.bool,
};

const EMBED_SCRIPT_SRC = process.env.NEXT_PUBLIC_HAPYAK_EMBED_SCRIPT_SRC;
const { VIEW_PAGE_EVENT, PLAYER_EVENT } = videoPlayerEvents;

const VideoEmbed = ({ src, user, contentId, showVeil }) => {
  const quizContext = useGetVideoQuizSubmission([contentId], [user.id]);
  const { data: quizResponseData, error } = quizContext;
  const {
    sendVideoPlayerEvent,
    setVideoEventBus,
    addVideoPlayerEventListener,
  } = useVideoEventBus();
  const context = user && shapeContextValue(user, contentId, showVeil);
  const formattedQuizData = shapeQuizResponseData(quizResponseData);
  const [isComponentMounted, setIsComponentMounted] = useState(false);
  const { isStudent } = getUserProperties(user);

  const handlePlayerLoadEvent = () => {
    if (isStudent && (quizResponseData || error)) {
      sendVideoPlayerEvent(
        VIEW_PAGE_EVENT.QUIZ_RESPONSE_DATA_LOADED,
        formattedQuizData,
      );
    }
  };

  addVideoPlayerEventListener(PLAYER_EVENT.LOADED_DATA, handlePlayerLoadEvent);

  useEffect(() => {
    setIsComponentMounted(true);
  }, []);

  const embedRef = useRef();

  const renderEmbed = () => {
    return (
      <hapyak-embed
        iframe="false"
        presentation="inline"
        context={JSON.stringify(context)}
        src={src}
        ref={embedRef}
        onload={setVideoEventBus(embedRef?.current?.eventBus)}
      />
    );
  };
  return (
    <>
      {/* The HapYak script can currently only be loaded clientside. */}
      {isComponentMounted ? (
        <Head>
          <script src={EMBED_SCRIPT_SRC} />
        </Head>
      ) : null}
      {showVeil ? <div css={addVeilCss}>{renderEmbed()}</div> : renderEmbed()}
    </>
  );
};

VideoEmbed.propTypes = propTypes;

export default VideoEmbed;
